import React, { useState, useEffect } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Col, Row } from 'react-bootstrap';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import {
  PAGINATION,
  SORT_BY,
  TABLE_NAME_STAKEHOLDER_ALERTS,
  STAKEHOLDER_ALERTS_COLUMNS,
} from 'constants/constants';
import { getStakeholderAlertsData } from 'store/customer/customer-view-actions';
import { getRestrictedColumn } from 'utils/utils';
import LinkButton from 'components/shared/button/LinkButton';

const StakeholderAlerts = ({ onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { selectedCustomer, columnsRestiction } = useSelector(
    (state) => state?.CustomerView
  );
  const { roleId } = useSelector((state) => state.Auth.userClaimObject);
  const initialState = {
    values: [],
    offset: 0,
    totalSize: 0,
  };
  const defaultPageSize = 5;
  const [stakeholderAlertsData, setStakeholderAlertsData] =
    useState(initialState);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [sortBy, setSortBy] = useState({
    column: 'surveyResponseDate',
    order: 'descend',
  });

  const pagination = {
    current: pageIndex,
    total: stakeholderAlertsData?.totalSize,
    onChange: (page, size) => {
      setPageIndex(page);
      setPageSize(size);
    },
    pageSize: pageSize,
    pageSizeOptions: [5, ...PAGINATION.pageSizeOptions],
    showSizeChanger: true,
    disabledPageSizehandler: true,
  };

  useEffect(() => {
    getStakeholderAlerts(sortBy.column, sortBy.order);
    setPageIndex(1);
    setPageSize(defaultPageSize);
  }, []);

  const handleSorting = (column, order, pagination) => {
    let offset = Math.ceil(
      pagination?.current * pagination?.pageSize - pagination?.pageSize
    );

    let currentPageSize = pagination.pageSize;
    if (pageSize !== currentPageSize) {
      offset = 0;
      setPageSize(currentPageSize);
    }

    setPageIndex(pagination.current);
    setSortBy({ column, order });

    getStakeholderAlerts(
      column,
      SORT_BY[order] ? SORT_BY[order] : undefined,
      offset,
      currentPageSize
    );
  };

  const getStakeholderAlerts = async (
    sortByColumn,
    sortByDirection,
    offset = 0,
    pageSize = defaultPageSize
  ) => {
    try {
      const qlikToken = localStorage.getItem('qlikToken');
      const qlikCookie = localStorage.getItem('qlikCookie');
      setIsLoading(true);
      const payload = {
        sortBy: sortByColumn,
        order: sortByDirection,
        limit: pageSize,
        offset,
        filterExpression: `Count({<Customer_Id={"${selectedCustomer?.value}"}, RoleId={"${roleId}"}>}distinct voc_surveyid)`,
      };
      const result = await getStakeholderAlertsData(
        payload,
        qlikToken,
        qlikCookie
      );
      setIsLoading(false);
      if (result?.values?.length > 0) {
        setStakeholderAlertsData(result);
      } else {
        setStakeholderAlertsData(initialState);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  return (
    <Fade cascade>
      <Row>
        <Col md={12}>
          <Spin spinning={isLoading}>
            <ConfigurableTable
              rows={stakeholderAlertsData?.values ?? []}
              columns={getRestrictedColumn(
                TABLE_NAME_STAKEHOLDER_ALERTS,
                STAKEHOLDER_ALERTS_COLUMNS,
                columnsRestiction
              ).map((col) => ({
                ...col,
                sortOrder:
                  sortBy.column === col.dataIndex ? sortBy.order : null,
              }))}
              enableColumnSelection={false}
              enableExport={false}
              tableName={TABLE_NAME_STAKEHOLDER_ALERTS}
              pagination={pagination}
              isGlobalSort={true}
              onSort={handleSorting}
              dimentions={{ x: 1200, y: 500 }}
              customCss='custom-table gne-table'
            />
          </Spin>
        </Col>
        {/* Risk Driver Legend */}
        <div
          className='mb-3'
          style={
            stakeholderAlertsData?.values.length > 0
              ? { marginTop: '-3rem' }
              : {}
          }>
          <small className='title title__x-small title__bold'>
            <i className='icon icon__warning icon_box'></i>= Risk Driver
          </small>
        </div>
      </Row>
      <Row>
        <LinkButton
          className='text text__small justify-content-end pe-3 pt-3'
          onClick={onClose}>
          Close
        </LinkButton>
      </Row>
    </Fade>
  );
};

export default StakeholderAlerts;
